
import React from "react";
import { useState,useEffect } from "react";
import { Helmet } from 'react-helmet';
import ScoutSidebar from "./ScoutSidebar";
import './classes/CreateScoutReport.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';

const CreateScoutReport = () =>{
    const [isLoading, setIsLoading] = useState(true);
    const [toggle, setToggle] = useState(2);
    const [errors, setErrors] = useState({});   
    const [tempImage, setTempImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);   
    const [tempFile, setTempFile] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [PreviewFields, setPreviewFields] = useState(false);
    const[message,setMessage] = useState([]);
    const [previewData, setPreviewData] = useState(null);     
    
    const location = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    const {rid} = useParams();
    
    const {tab} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    


   useEffect(() => {
                 Promise.all([
                     checkpermissionforpageaccess()
                 ])
                 .then(() => {
              
                 setIsLoading(false);
                 })
              
             },[]);
              async function checkpermissionforpageaccess() {
       
          
               const response = await fetch(
                    app_url+'smwwscout/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                   {
                       method: "GET",
     
                       headers: {
                       'Content-Type': 'application/json',
                       },
                   }
               )           
               const responsedata = await response.json();
               if(responsedata.data.msg === "Success") {
                   
               } 
                if(responsedata.data.msg === "Error") {
                   setMessage(responsedata.data.result);
               } 
   
          
       }

    const initialFormData = {
        title: '',
        field_scout_report:'',
        field_scout_report_image:'',
        field_scout_report_sport:'',
        drupal_uid:localStorage.getItem('drupal_uid'),
        button_name:'Save',
    };
    const [formData, setFormData] = useState(initialFormData);
    const [selectedSport,setSelectedSport] = useState('');
    const [imageUploadError, setImageUploadError] = useState('');
    const [fileUploadError, setFileUploadError] = useState('');
    const [imageRemoved, setImageRemoved] = useState(false);
    const [savedData, setSavedData] = useState(initialFormData);
    const [disabled, setDisabled] = useState(false);
  

  const getFullFileUrl = (path) => {
    if (!path) return "";
    
    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
    }

    // Update with actual file server path
    const baseUrl = window.location.origin;
    return `${baseUrl}/${path}`;
  };



  const sportsOptions = [
      "actions sports", "basketball", "baseball", "boxing", "cricket", "extreme sports",
      "football", "golf", "hockey", "motor sports", "martial arts", "Olympic sports",
      "track and field", "rugby", "tennis", "soccer"
  ];

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

  const handleChange = (e) => {
      const { name, value } = e.target;

      if (name === "field_scout_report_sport") {
          setSelectedSport(value);  
      }

      setFormData(prev => ({ ...prev, [name]: value }));
  };

    // Handle file change
    const handleTempFileChange = (e) => {
      const file = e.target.files[0];

      if (file) {
        setTempFile(file); // Store the file temporarily
      }
      const allowedFileTypes = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'txt', 'wps', 'jpg', 'png', 'gif', 'html'];
const fileExtension = file.name.split('.').pop().toLowerCase();

if (!allowedFileTypes.includes(fileExtension)) {
  const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>${allowedFileTypes.join(', ')}</em>`;
  setFileUploadError(errorHTML);
  e.target.value = '';
  setTempFile(null);
  return;
}

setFileUploadError(''); // clear error if valid
setTempFile(file);

    };

    // Confirm upload
    const handleUploadClick = () => {
      if (tempFile) {
        setSelectedFile(tempFile); // Set the selected file
        setFormData(prev => ({
          ...prev,
          field_scout_report: tempFile.name, // Store just the file name
        }));
      }
    };

// Remove file
const removeFile = () => {
  setSelectedFile(null);
  setTempFile(null);
  setFormData(prev => ({
    ...prev,
    field_scout_report: "",
    field_delete_file: 1,
  }));
};

const handleTempImageChange = (e) => {
  const files = Array.from(e.target.files);
  const file = files[0];
  if (!file) return;

  const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
  const maxSize = 128 * 1024 * 1024;
  const errors = [];

  if (!validTypes.includes(file.type)) {
    errors.push('Allowed file types: png, gif, jpg, jpeg.');
  }

  if (file.size > maxSize) {
    errors.push('File must be less than 128 MB.');
  }

  if (errors.length > 0) {
    const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>`;
    setImageUploadError(errorHTML);
    e.target.value = '';
    setTempImage(null);
    return;
  }

  setImageUploadError(''); // Clear previous error
  const objectUrl = URL.createObjectURL(file);
  setTempImage({
    file,
    preview: objectUrl
  });
};
const handleImageUploadClick = () => {
  if (tempImage) {
    setSelectedImage(tempImage);
    setFormData(prev => ({
      ...prev,
      field_scout_report_image: tempImage.file
    }));
    setImageUploadError(''); // Clear error on successful upload
  }
};



// Remove image
const removeImage = () => {
  setSelectedImage(null);
  setTempImage(null);
  setFormData(prev => ({
    ...prev,
    field_scout_report_image: "",
    field_delete_scout_report_image: 1,
  }));
};

 const formatFileSize = (size) => {
    if (size < 1024) return size + " Bytes";
    else if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
    else return (size / (1024 * 1024)).toFixed(2) + " MB";
  };


const validateForm = () => {
  const newErrors = {};

  if (!formData.title.trim()) {
    newErrors.title = 'Title field is required.';
  }
  if (!formData.field_scout_report.trim()) {
    newErrors.field_scout_report = "File to Upload field is required.";
  }
  if (!formData.field_scout_report_sport.trim()) {
    newErrors.field_scout_report_sport = "Sport field is required.";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

 const inputStyle = {
  title: {
    border: errors.title ? '2px solid red' : '1px solid #777'
  },
  field_scout_report_sport:{
    border: errors.title ? '2px solid red' : '1px solid #777'
  },
  field_scout_report:{
    border: errors.title ? '2px solid red' : '1px solid #777'
  },
 };
const handleSubmit = async (e) => {
        e.preventDefault();
        setFileUploadError('');
        setImageUploadError('');
        setFormData(prevState => ({
            ...prevState,
            button_name: "Saving..."
        }));
        setDisabled(true);
        const postData = new FormData();
          if (selectedImage && selectedImage.file) {
            postData.append('field_scout_report_image', selectedImage.file);
           }

        // Append document file
        if (selectedFile) {
          postData.append('scout_report_file', selectedFile);
        }

        // Append the rest of the form fields as JSON
        const { field_scout_report_image, ...rest } = formData; // remove image from formData
        postData.append('formData', JSON.stringify(rest));
       
         if (validateForm()) {
            const response = await fetch(app_url+'smwwscout/addscoutreport', {
            method: 'POST',
            body: postData,
        
        });
            const data = await response.json();
              if(data.data.msg == "Success") {
              setFormData(prevState => ({
                ...prevState,
                button_name: "Save"
              })); 
              setDisabled(false);                
                 navigate('/scout-report/'+data.data.id+'/view', { state: { message: data.data.result } });
            } 
           
        }
    };
  const imageValue = selectedImage ? selectedImage.file : formData.field_scout_report_image;
  const fileName =
    imageValue && typeof imageValue === "object" && imageValue.name
      ? imageValue.name
      : typeof imageValue === "string"
      ? imageValue.split("/").pop()
      : "";
    return(
        <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">
                  <Helmet>
                      <title>Create Scout Report</title>
                  </Helmet>
            <div className="left"></div>
            <div className="center left-center">

                                {Object.values(errors).some(msg => !!msg) && (
                                  <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                                    <ul>
                                      {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                          <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                <div className="create-scout-report-container"> 
                  {message.length > 0 ? (
                <div>
                  {message.map((item, index) => {
                    return <><div dangerouslySetInnerHTML={{ __html: item }} /><br /></>
          
                  })}  
                </div>
              ) : (
                <>
                  <h1>Create Scout Report</h1>              
                    <form onSubmit={handleSubmit}>
                      <div className="form-item field-title">
                          <label htmlFor="edit-title">
                          Title <span className="form-required" title="This field is required.">*</span>
                          </label>
                          <input
                            type="text"
                            id="edit-title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            size="60"
                            maxLength="255"
                            className="form-text required" 
                            style={inputStyle.title}                       
                          />
                      </div>
                      <div>
                        <label>File to Upload <span className="form-required" title="This field is required.">*</span></label>
                         {fileUploadError && (
                           <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                          <div 
                            style={{ color: '#8c2e0b',                                
                                backgroundColor: '#fef5f1',                                 
                                marginBottom: '10px', 
                                width: '80%',
                                borderRadius: '5px'                                 
                            }}
                             dangerouslySetInnerHTML={{ __html: fileUploadError }}
                            >                           
                          </div>
                          </div>
                        )}
                        {selectedFile ? (
                            /* file selected and upload button clicked */
                        <div className="edit-scout-report-file-container">
                          <span className="file">
                            <img
                              className="file-icon"
                              alt="File icon"
                              src={getFileIcon(selectedFile.name)}
                              width="16"
                              height="16"
                            />
                            <a
                              href={URL.createObjectURL(selectedFile)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="file-name-link"
                              onClick={(e) => {
                                e.preventDefault();
                                window.open(URL.createObjectURL(selectedFile), "_blank");
                              }}
                            >
                              {selectedFile.name}
                            </a>
                            <span className="file-size">({formatFileSize(selectedFile.size)})</span>
                          </span>
                        </div>                         
                        ) : formData.field_scout_report ? (
                        // Case 1: File already saved in backend
                          <div className="edit-scout-report-file-container">
                            <span className="file">
                              <img
                                className="file-icon"
                                alt="File icon"
                                src={getFileIcon(formData.field_scout_report)}
                              />
                              <a
                                href={formData.field_scout_report}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="file-name-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          const fileUrl = selectedFile 
                                              ? URL.createObjectURL(selectedFile) 
                                              : getFullFileUrl(formData.field_scout_report);
                                          window.open(fileUrl, "_blank"); 
                                        }}
                                >
                                {formData.field_scout_report}
                              </a>
                            </span>
                          </div>
                      ) : (
                        /* no file selected/uploaded yet - show input + upload button */
                        <div>
                          <input
                            type="file"
                            id="edit-scout-report-file-upload"
                            className="scout-file-upload"
                            name="field_scout_report"
                            onChange={handleTempFileChange}
                            style={inputStyle.field_scout_report}
                          />
                          <input
                            type="button"
                            value="Upload"
                            className="form-submit"
                            onClick={handleUploadClick}
                            disabled={!tempFile}  // optionally disable upload if no file selected
                          />
                        </div>
                        )}           

                       {(selectedFile || (formData.field_scout_report && formData.field_scout_report.length > 0)) ? (
                        <input
                          type="button"
                          value="Remove"
                          className="form-submit"
                          onClick={removeFile}
                        />
                      ) : (
                        <div className="description">
                          Files must be less than <b>128 MB</b>.<br />
                          Allowed file types: <b>doc docx xls xlsx pdf txt wps jpg png gif html</b>.
                        </div>
                      )}
                      </div>
                        <br/>
                      <div>                       
                        <div>
                          <label>Image to Upload</label>
                           {imageUploadError && (
                              <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                          <div 
                            style={{ color: '#8c2e0b',
                                backgroundColor: '#fef5f1',
                                marginBottom: '10px', 
                                width: '80%',
                                borderRadius: '5px' 
                            }}
                             dangerouslySetInnerHTML={{ __html: imageUploadError }}
                            >                           
                          </div>
                          </div>
                        )}
                          {selectedImage ? (
                            // Case 1: New image selected
                            <div className="edit-agent-image-container">
                              <img alt="Uploaded" src={selectedImage.preview} width="90" height="100" />
                              <div className="image-info">
                                  <img
                                className="file-icon"
                                alt="File icon"
                                src={getFileIcon(selectedImage.file.name)}
                              />
                                <a
                                  href={selectedImage.preview}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="image-name-link"
                                >
                                  {selectedImage.file.name}
                                </a>
                                <span className="image-size">
                                  ({(selectedImage.file.size / 1024).toFixed(2)} KB)
                                </span>
                              </div>
                            </div>
                          ) : formData.field_scout_report_image ? (
                            // Case 2: Image already saved (URL string from backend)
                            <div className="edit-scout-report-image-container">
                              <img
                                alt="Uploaded"
                                src={formData.field_scout_report_image}
                                width="90"
                                height="100"
                              />
                              <div className="image-info">
                                <a
                                  href={formData.field_scout_report_image}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="image-name-link"
                                >
                                  {fileName}
                                </a>
                              </div>
                            </div>
                          ) : (
                            // Case 3: No image yet → show upload input
                            <div>
                              <input
                                type="file"
                                id="edit-agent-photo-upload"
                                name="edit_agent_photo_upload"
                                accept="image/*"
                                onChange={handleTempImageChange}
                              />
                              <input
                                type="button"
                                value="Upload"
                                className="form-submit"
                                onClick={handleImageUploadClick}
                              />
                            </div>
                          )}

                          {(selectedImage || formData.field_scout_report_image) && (
                            <input
                              type="button"
                              value="Remove"
                              className="form-submit"
                              onClick={removeImage}
                            />
                          )}

                          {!formData.field_scout_report_image && !selectedImage && (
                            <div className="description">
                              Files must be less than <b>128 MB</b>.<br />
                              Allowed file types: <b>png gif jpg jpeg</b>.
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form-item field-scout-report-sport">
                        <label htmlFor="edit-field-scout-report-sport">
                          Sport <span className="form-required" title="This field is required.">*</span>
                        </label>     
                        <select
                          id="edit-field-scout-report-sport"
                          name="field_scout_report_sport"
                          value={formData.field_scout_report_sport}  
                          onChange={handleChange}
                          style={inputStyle.field_scout_report_sport}
                        >
                          <option value="_none">- Select a value -</option>
                          {sportsOptions.map((sport) => (
                            <option key={sport} value={sport}>
                              {sport}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        {/* <input type="submit" className="form-submit" value="Save"/> */}
                        <button type="submit" className="form-submit" disabled={disabled}>{formData.button_name}</button>
                      </div>
                    </form>
                    </>
              )}
               </div>
               
            </div>
            <div className="right">
                <ScoutSidebar/>
            </div>
        </div>
            )}
            </>
    );
};
export default CreateScoutReport;
